<template>
  <v-bottom-nav class="ids-bottom-nav" :active.sync="activeBtn" :value="showNav" style="height:inherit;">
    <template class="bottom_nav_list">
      <v-btn v-for="(bottom, index) in bottoms" :key="index" :class="[bottom.style, { bottom_nav: true }]"
        :value="bottom.name" @click="Go2Web(bottom, bottom.click.params)" :disabled="bottom.disabled">
        <span>{{ $t(bottom.name) }}</span>
        <v-badge dot overlap color="red">
          <span v-if="bottom.tips" slot="badge" />
          <v-icon>{{ bottom.icon }}</v-icon>
        </v-badge>
      </v-btn>
    </template>
  </v-bottom-nav>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { styleNo } from '../config/BottomBtn'

// config
import msgbus from '../msgBus'
import tools from '../util/tools'

export default {
  name: 'iDS-BottomNav',
  data: function () {
    return {
      showNav: true,
      activeBtn: ''
    }
  },

  computed: {
    bottoms() {
      var bottoms = tools.getCopy(this.getBottomNavButtons())
      bottoms.forEach(bottom => {
        bottom.style = styleNo[bottoms.length]
      })
      return bottoms
    }
  },

  methods: {
    Go2Web(bottom, url) {
      this.$router.replace({ name: url })
    },
    ...mapGetters('app', ['getBottomNavButtons', 'getBottomActiveBtn']),
    ...mapMutations('app', ['setBottomActiveBtn'])
  },

  mounted: function () {
    this.activeBtn = this.getBottomActiveBtn()
    var tmp = document.getElementsByClassName('ids-bottom-nav')[0]
    msgbus.vm.setContentBottomHeight({ value: tmp.clientHeight + 2 + 'px' })
  },

  updated: function () {
    var tmp = document.getElementsByClassName('ids-bottom-nav')[0]
    msgbus.vm.setContentBottomHeight({ value: tmp.clientHeight + 2 + 'px' })
  },

  beforeDestroy() {
    this.setBottomActiveBtn({ value: this.activeBtn })
  }
}
</script>

<style lang="scss">
.ids-bottom-nav {
  overflow: hidden;
  border-top: 1px solid #e7e7e7;
  border-bottom: 1px solid #f8f8f8;

  & .v-btn {
    filter: inherit !important;
    opacity: inherit;
    color: gray;

    &.v-btn--active {
      color: #1e88e5;
    }

    & .v-btn__content {
      font-size: 12px !important;
    }

    & .v-btn__content i {
      font-size: 24px;
      height: 24px;
      line-height: 24px;
    }
  }

  & button {
    padding: 6px 0 !important;

    &.bottom_nav.one {
      max-width: 100%;
    }

    &.bottom_nav.two {
      max-width: 50%;
    }

    &.bottom_nav.three {
      max-width: 33.33%;
    }

    &.bottom_nav.four {
      max-width: 25%;
      min-width: 25%;
    }

    &.bottom_nav.five {
      max-width: 20%;
      min-width: 20%;
    }
  }

  & .v-badge {
    & .v-badge__badge {
      font-size: 12px;
      height: 9px;
      width: 9px;
      bottom: calc(100% - 5px);
      left: calc(100% - 2px);
      right: auto;
      top: auto;
    }
  }
}
</style>
